
<template>

  <Layout>

    <PageHeader :title="title" :items="items" />


   

    <div class="row">

      <div class="col-12">

        <div class="card shadow-lg">

          <div class="card-body">

            <div class="mb-2 float-end">

              <b-button v-b-modal.new-prn size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Subscription</b-button>

            </div>

            <div class="clearfix"></div>

            <div class="row">

              <div class="col-sm-12 col-md-6">

                <div id="tickets-table_length" class="dataTables_length">

                  <label class="d-inline-flex align-items-center">

                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries

                  </label>

                </div>

              </div>

              <div class="col-sm-12 col-md-6">

                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >

                  <label class="d-inline-flex align-items-center">

                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>

                  </label>

                </div>

              </div>

            </div>

            <div class="table-responsive">

              <b-table

                :items="Items"

                :fields="Fields"

                responsive="sm"

                :per-page="perPage"

                :current-page="currentPage"

                :filter="filter"

                :filter-included-fields="filterOn"

                @filtered="Filtered"

                :busy="IsBusy"

              >

              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>

              <template #cell(index)="data">

                {{ data.index + 1 }}

              </template>




              <template #cell(updated_at)="data">

                  {{ new Date(data.item.updated_at).toLocaleDateString('en-US', options) }}

              </template>
             
              </b-table>

            </div>

            <div class="row">

              <div class="col">

                <div class="dataTables_paginate paging_simple_numbers float-end">

                  <ul class="pagination pagination-rounded mb-0">

                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>

                  </ul>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>




     <b-modal id="new-prn" centered title="New Subscription" title-class="font-18" hide-footer>

        <form @submit.prevent="pay">

            <div class="form-group mb-2">

                <label>Service</label>

                <v-select :options="services" @input="FindProduct" placeholder="Select a Service" v-model="service"></v-select> <br>

                          <div class="row">


                <!-- <label>Product</label>

                <v-select :options="products" @input="FindPrice" placeholder="Select a Product" v-model="product"></v-select> -->


                                <div class="row">

                <div class="col">

                  <label>Package</label>

                  <v-select :options="products" @input="FindPrice" placeholder="Select a Package" v-model="product"></v-select>

                </div>

                <div class="col" v-show="service =='Software Subscription' ">
                
                  <label>Months to Pay</label>
                
                  <input v-model="monthsToPay" @change="CalculateAmount" type="number" min="1" class="form-control" />
                  
                </div>

                </div>
                <label>Amount</label>
                <input v-model="calculatedAmount" type="text" class="form-control" :readonly = "true" />




                <div class="form-group mb-2">

                  <label>Mobile Money Number</label>

                  <b-input-group prepend="+256"><input v-model="telephone" placeholder="Enter Telephone" v-mask="'#########'" type="text" class="form-control"/></b-input-group>

                </div>

            </div>

            <div class="form-group d-flex justify-content-end">

                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-prn')" >Close</b-button>

                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>

            </div>

              </div>

        </form>

    </b-modal> 

   <b-modal id="waiting-confirm" centered title-class="font-18" hide-footer>

      <div class="text-center">  

        <b>{{ responseMessage }}</b><br><br>

        <b-spinner class="align-middle" type="grow" style="width: 5rem; height: 5rem;"></b-spinner>

      </div>

      <div class="form-group d-flex justify-content-end">

          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('waiting-confirm')" >Close</b-button>

      </div>

    </b-modal>




  </Layout>

</template>




<script>

import axios from "axios";

import Layout from "../../layouts/main";

import PageHeader from "@/components/page-header";

import appConfig from "@/app.config";

import { subscriptionMethods, subscriptionComputed } from "@/state/helpers";




export default {

  page: {

    title: "Subscriptions",

    meta: [{ name: "description", content: appConfig.description,},],

  },

  components: {

    Layout,PageHeader

  },

  data() {

    return {

      userData: JSON.parse(localStorage.getItem("user")),
     

      title: "Subscriptions",

      items: [ {text: "Dashboard",to: "/",}, {text: "Subscriptions",active: true, }, ],

      TotalRows: 1,

      currentPage: 1,

      perPage: 10,

      Options: [10, 50, 100, 150, 200],

      filter: null,

      todoFilter: null,

      filterOn: [],

      sortDesc: true,

      isBusy: true,

      fields: [

          { key: 'index', label: '#', visible: true },

          { key: 'id', label: 'ID', visible: false },

          { key: 'service', label: 'Service', visible: true },

          { key: 'amount', label: 'Amount', visible: true },

          { key: 'telephone', label: 'Telephone', visible: true },

          { key: 'updated_at', label: 'Paid On', visible: true },

        ],

      id:'',

      name:'',
      
      

      baseAmount:0,

      monthsToPay: 1,

    

      services:["Software Subscription","SMS Purchase"], service:"",

      products:[], product:"", amount:"",telephone:"", responseMessage:"", 

      options : { weekday: "short", year: "numeric", month: "long", day: "numeric", hour: 'numeric'},

    };

  },

  computed: {

    ...subscriptionComputed,

    List() { return this.subscriptions.length; },

    Fields() { return this.fields.filter(field => field.visible) },

    Items() { return this.subscriptions.map((d) => ({...d }))},

    IsBusy() { let a=false; if (this.subscriptions.length>0) { a=false;} else { a=true;} return a },

    calculatedAmount() {
      return this.baseAmount * this.monthsToPay;
    },

  },

  

  mounted() {

    this.fetchSubscriptions();

    this.TotalRows = this.subscriptions.length;

    this.isBusy=false;
    

  },

  methods: {

    ...subscriptionMethods,

    Filtered(filteredItems) {

      this.TotalRows = filteredItems.length;

      this.currentPage = 1;

    },

    // FindProduct(){

    //     if (this.service=="Software Subscription") {

    //         this.products = ["Yearly Subscription","Monthly Subscription"]

    //     } else {

    //         this.products = ["Starter Pack - 2500 sms","Premium Pack - 5000 sms","Enterprise Pack - 10000 sms"]

    //     }

    // },

    FindProduct(){

        if (this.service=="Software Subscription") {
          
            // this.products = ["Yearly Subscription","Monthly Subscription"]
            this.products = ["Monthly Subscription"]

        } else {

            this.products = ["Starter Pack - 2500 sms","Premium Pack - 5000 sms","Enterprise Pack - 10000 sms"]

        }

        this.product = "";

        this.baseAmount = 0;

        this.amount = 0;

        this.monthsToPay = 1;


        },

    // FindPrice(){

    //     if (this.product=="Yearly Subscription") {

    //         this.amount = 500000;

    //     } else if(this.product=="Monthly Subscription"){

    //         this.amount = 50000;

    //     } else if(this.product=="Starter Pack - 2500 sms"){

    //         this.amount = 1000;

    //     } else if(this.product=="Premium Pack - 5000 sms"){

    //         this.amount = 30000;

    //     } else if(this.product=="Enterprise Pack - 10000 sms"){

    //         this.amount = 50000;

    //     } else {

    //         this.amount = 0;

    //     }

    // },
    FindPrice(){

// if (this.product=="Yearly Subscription") {

//     this.amount = 500000;

// } 
 if(this.product=="Monthly Subscription"){

    // this.amount = 50000;
    this.baseAmount = this.userData.monthly_charge;


} else if(this.product=="Starter Pack - 2500 sms"){


    this.baseAmount = 1000;


} else if(this.product=="Premium Pack - 5000 sms"){


    this.baseAmount = 30000;


} else if(this.product=="Enterprise Pack - 10000 sms"){


    this.baseAmount = 50000;


} else {


    this.baseAmount = 0;


}


this.CalculateAmount();
},

CalculateAmount() {

      
      if (!this.monthsToPay || this.monthsToPay < 1) {

        this.monthsToPay = 1;

      }

      this.amount = this.baseAmount * this.monthsToPay;

    },
      async pay(){

      let formData = new FormData();

      formData.append("telephone", this.telephone);

      formData.append("amount", this.amount);

      formData.append("service", this.product);
      formData.append("months_paid", this.monthsToPay);

      let url = "/makesubscription";

      await axios.post(url, formData).then((response) => {

      if (response.data.code == 200) {

          this.responseMessage=response.data.message;

          this.$bvModal.hide('new-prn');

          this.$bvModal.show('waiting-confirm');

          this.interval = setInterval(async () => { await this.ConfirmPayment(response.data.reference); }, 5000 * 5);

      }

      });

    },

   


    async ConfirmPayment(reference){

      let formData = new FormData();

      formData.append("reference", reference);

      let url = "/confirmpayment";

      await axios.post(url, formData).then((response) => {

        if (response.status == 200) { 

          if (response.data.code=='200') {

              this.$bvModal.hide('waiting-confirm');

              clearInterval(this.interval);

              this.fetchSubscriptions();

              this.$swal({ title:'Success', text:response.data.message + 'Please re-login to extend your license', icon:'success'});
              // this.updateLicense();
            }

        }

      });

    },

  },
  
  destroyed() {

    clearInterval(this.interval);

  },
  // async updateLicense() {
  //     let url = "/edit_license";
  //     let endDate = this.product === "Yearly Subscription" ? new Date().setFullYear(new Date().getFullYear() + 1) : new Date().setMonth(new Date().getMonth() + 1);
  //     let formData = new FormData();
  //     formData.append("startdate", new Date().toISOString().split('T')[0]);
  //     formData.append("enddate", new Date(endDate).toISOString().split('T')[0]);
  //     formData.append("id", this.userData.license_id); // Assuming license_id is stored in user data
  //     await axios.post(url, formData).then((response) => {
  //       if (response.status == 200) {
  //         localStorage.setItem('license', response.data.enddate);
  //       }
  //     });
    
  // },

};

</script>


